import { defineField, defineType } from 'sanity'
import getPageInfo, { seoGroup } from '../../objects/pageInfo'
import { strongEmLink } from '../../../data/richText'

export default defineType({
  name: 'fitmentGuidesHome',
  title: 'Fitment Guides Home',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      name: 'title',
      title: 'Title',
      description: 'Shows on fitment guides index pages',
      type: 'string',
      group: 'content',
    }),
    defineField({
      name: 'description',
      title: 'Description',
      description: 'Shows on fitment guides index pages',
      type: 'array',
      of: strongEmLink,
      group: 'content',
    }),
    getPageInfo({ lockCanonical: true }),
  ],
})